import React from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { retryLoad } from './util/loadableUtil';
import HeaderAppBar from './components/header/HeaderAppBar';
import IndexPage from './components/index/IndexBox';
import Footer from './components/common/footer/Footer';
import AdminNavbar from './components/admin/AdminTemplate';
import LogCheck from './components/common/api/LogCheck';
import ReactHelmet, {
  ReactHelmetScript,
} from './components/common/ReactHelmet';
import CPMailManagePage from './pages/admin/CPMailManagePage';
const LoginPage = retryLoad(() => import('./pages/user/LoginPage'));
const RegisterPage = retryLoad(() => import('./pages/user/RegisterPage'));
const MyPage = retryLoad(() => import('./pages/user/MyPage'));
const CoursePage = retryLoad(() => import('./pages/user/CoursePage'));
const LearningPage = retryLoad(() => import('./pages/user/LearningPage'));
const OrderPage = retryLoad(() => import('./pages/user/OrderPage'));
const MoviePage = retryLoad(() => import('./pages/user/popup/MoviePage'));
const SampleMoviePage = retryLoad(
  () => import('./pages/user/popup/SampleMoviePage'),
);
const PointPage = retryLoad(() => import('./pages/user/popup/PointPage'));
const HelpPage = retryLoad(() => import('./pages/user/HelpPage'));
const SearchPage = retryLoad(() => import('./pages/user/SearchPage'));
const ReviewPage = retryLoad(() => import('./pages/user/ReviewPage'));
const ReviewFormPage = retryLoad(
  () => import('./pages/user/popup/ReviewFormPage'),
);
const IDPWSearchPage = retryLoad(() => import('./pages/user/IDPWSearchPage'));
const SurveyPage = retryLoad(() => import('./pages/user/popup/SurveyPage'));
const AdminMoviePage = retryLoad(
  () => import('./pages/user/popup/AdminMoviePage'),
);
const AdminProductPriorityUpdatePage = retryLoad(
  () => import('./pages/user/popup/AdminProductPriorityUpdatePage'),
);
const NotFoundPage = retryLoad(() => import('./pages/user/NotFoundPage'));
const ReceiptPage = retryLoad(() => import('./pages/user/popup/ReceiptPage'));
const IntroPage = retryLoad(() => import('./pages/user/IntroPage'));
const RoadMapPage = retryLoad(() => import('./pages/user/RoadMapPage'));
const FreePage = retryLoad(() => import('./pages/user/FreePage'));
const CommunityPage = retryLoad(
  () => import('./pages/user/community/CommunityPage'),
);
const ResourcePage = retryLoad(() => import('./pages/user/ResourcePage'));

// certificate popup pages
const CertificatePage = retryLoad(
  () => import('./pages/user/popup/CertificatePage'),
);

//admin pages
// const AdminIndexPage = (retryLoad(() => import('./pages/admin/IndexPage')));
const AdminUserPage = retryLoad(() => import('./pages/admin/UserPage'));
const AdminMemoPage = retryLoad(() => import('./pages/admin/UserMemoPage'));
const AdminManagerPage = retryLoad(() => import('./pages/admin/ManagerPage'));
const AdminPermissionPage = retryLoad(
  () => import('./pages/admin/PermissionPage'),
);
const AdminRolePage = retryLoad(() => import('./pages/admin/RolePage'));
const AdminPointPage = retryLoad(() => import('./pages/admin/PointPage'));
const AdminCoursePage = retryLoad(() => import('./pages/admin/CoursePage'));
const AdminTemporaryPage = retryLoad(
  () => import('./pages/admin/TemporaryPage'),
);
const AdminBookPage = retryLoad(() => import('./pages/admin/BookPage'));
const AdminBookDeliveryPage = retryLoad(
  () => import('./pages/admin/BookDeliveryPage'),
);
const AdminProductPage = retryLoad(() => import('./pages/admin/ProductPage'));
const AdminPeriodPage = retryLoad(() => import('./pages/admin/PeriodPage'));
const AdminLearningCoursePage = retryLoad(
  () => import('./pages/admin/LearningCourse'),
);
const AdminPausePage = retryLoad(() => import('./pages/admin/PausePage'));
const AdminOrderPage = retryLoad(() => import('./pages/admin/OrderPage'));
const AdminInquiryPage = retryLoad(() => import('./pages/admin/InquiryPage'));
const AdminPostPage = retryLoad(() => import('./pages/admin/PostPage'));
const AdminFAQPage = retryLoad(() => import('./pages/admin/FAQPage'));
const AdminSettingPage = retryLoad(() => import('./pages/admin/SettingPage'));
const AdminReviewPage = retryLoad(() => import('./pages/admin/ReviewPage'));
const AdminAnalysisPage = retryLoad(() => import('./pages/admin/AnalysisPage'));
const AdminCPPage = retryLoad(() => import('./pages/admin/CPPage'));
const AdminCPPayPage = retryLoad(() => import('./pages/admin/CPPayPage'));
const AdminCommunityBoardPage = retryLoad(
  () => import('./pages/admin/CommunityBoardPage'),
);
const AdminResourcePage = retryLoad(() => import('./pages/admin/ResourcePage'));

const App = () => {
  return (
    <>
      <ReactHelmetScript />
      <LogCheck />
      <Switch>
        {/* 팝업페이지 */}
        <Route component={AdminCPPayPage} path="/admin/cppay" />
        <Route
          component={AdminMoviePage}
          exact
          path="/admin/adminMovie/:lecId"
        />
        <Route
          component={AdminProductPriorityUpdatePage}
          exact
          path="/admin/adminProductUpdate"
        />
        <Route
          path="/admin"
          render={() => (
            <AdminNavbar>
              <ReactHelmet title="관리자모드" />
              <Switch>
                <Route
                  component={() => <Redirect to="/admin/user" />}
                  path="/admin"
                  exact
                />
                {/* <Route component={AdminIndexPage} path="/admin/index" /> */}

                {/* 부관리자도 볼 수 있는 페이지 */}
                <Route component={AdminUserPage} path={'/admin/user'} />

                <Route component={AdminOrderPage} path="/admin/order" />
                <Route
                  component={AdminBookDeliveryPage}
                  path="/admin/delivery"
                />
                <Route
                  component={CPMailManagePage}
                  path="/admin/CPMailManagePage"
                />

                <Route component={AdminPeriodPage} path="/admin/period" />
                <Route component={AdminPausePage} path="/admin/pause" />

                <Route component={AdminCoursePage} path="/admin/course" />
                <Route component={AdminBookPage} path="/admin/book" />
                <Route component={AdminProductPage} path="/admin/product" />

                {/* 최상위 관리자만 볼 수 있는 페이지 */}
                <Route component={AdminMemoPage} path="/admin/memo" />
                <Route component={AdminManagerPage} path="/admin/manager" />
                <Route
                  component={AdminPermissionPage}
                  path="/admin/permission"
                />
                <Route component={AdminRolePage} path="/admin/role" />
                <Route component={AdminPointPage} path="/admin/point" />
                <Route
                  component={AdminLearningCoursePage}
                  path="/admin/learning"
                />
                <Route component={AdminTemporaryPage} path="/admin/temporary" />
                <Route component={AdminReviewPage} path="/admin/review" />
                <Route component={AdminFAQPage} path="/admin/faq" />
                <Route component={AdminInquiryPage} path="/admin/inquiry" />
                <Route component={AdminPostPage} path="/admin/post" />
                <Route
                  component={AdminCommunityBoardPage}
                  path="/admin/community"
                />
                <Route component={AdminSettingPage} path="/admin/setting" />
                <Route component={AdminAnalysisPage} path="/admin/analysis" />
                <Route component={AdminCPPage} path="/admin/cplist" />
                <Route component={AdminResourcePage} path="/admin/resource" />
              </Switch>
            </AdminNavbar>
          )}
        />
        {/* 이용자모드 팝업페이지 */}
        <Route component={SampleMoviePage} path="/moviePlayer/sample" />
        <Route component={MoviePage} path="/moviePlayer" />
        <Route component={ReviewFormPage} exact path="/reviewform" />
        <Route component={PointPage} exact path="/mypage/point" />
        <Route component={ReceiptPage} exact path="/receipt" />
        <Route component={SurveyPage} exact path="/survey/:surveyName" />
        <Route component={CertificatePage} path="/certificate" />
        {/* 공통헤더가있는 이용자모드 페이지 */}
        <Route
          render={() => (
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                background: 'white',
                overflowX: 'hidden',
              }}
            >
              <div
                style={{
                  minHeight: '100vh',
                }}
              >
                <HeaderAppBar />
                <ReactHelmet title="" />
                <Switch>
                  <Route component={IndexPage} exact path="/" />
                  <Route component={LoginPage} exact path="/login" />
                  <Route component={RegisterPage} path="/register" />
                  <Route component={IDPWSearchPage} path="/idpwsearch" />
                  <Route component={MyPage} path="/mypage" />
                  <Route component={CoursePage} path="/course" />
                  <Route component={OrderPage} path="/order" />
                  <Route component={HelpPage} path="/help" />
                  <Route component={SearchPage} exact path="/search" />
                  <Route component={ReviewPage} exact path="/review" />
                  <Route component={LearningPage} path="/learning" />
                  <Route component={IntroPage} exact path="/intro" />
                  <Route component={RoadMapPage} exact path="/roadmap" />
                  <Route component={FreePage} exact path="/free" />
                  <Route component={CommunityPage} path="/community" />
                  <Route component={ResourcePage} path="/resources" />
                  <Route component={NotFoundPage} />
                </Switch>
              </div>
              <Footer />
            </div>
          )}
        />
      </Switch>
    </>
  );
};

export default App;
